// @flow

import { combineEpics, ActionsObservable } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { SET_LANGUAGE, SET_LANGUAGE_DONE } from '../actions';
import type { I18nActions } from '../types';

export const i18nEpic = (action$: ActionsObservable<I18nActions>) =>
  action$.pipe(
    filter((action) => action.type === SET_LANGUAGE),
    map((action: I18nActions) => {
      return {
        type: SET_LANGUAGE_DONE,
        payload: action.payload
      };
    })
  );

export const i18nEpics = combineEpics(i18nEpic);
